import Api from '../api';

const resource = '/menu';

export default {
  get(code: string) {
    return Api.post(`${resource}`, {
      code,
    });
  },
};
